import { BaseService } from "./BaseService";

export class CalculationsetService extends BaseService {
  getCalculationsets(profileId) {
    return super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETTRANSACTIONFILTERSETS + "?profileID=" + profileId
    );
  }
}
